import React from "react"
import classnames from "classnames"
import styles from "./SpecificationsBlock.less"
import { GradePicker, AccordionTextList, Disclaimer } from "AtomicContainers"
import { H6, Caption, Space, Section } from "AtomicComponents"
import fetchAPI from "AtomicUtils/fetchAPI"
import { LoadingSection } from "AtomicComponents"

class SpecificationsBlock extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      loading: false,
      disclaimers: null,
      categories: null,
      activeDisclaimerCode: null
    }
  }

  _handleChange = ({
    bodystyle = "",
    drivetrain = "",
    grade = "",
    nameplate = "",
    isSafetyModel = false
  }) => {
    const { specsApiEndpoint } = this.props
    this.setState({
      loading: true,
      categories: null,
      disclaimers: null
    }, async () => {
      await fetchAPI({
        method: "POST",
        url: specsApiEndpoint,
        body: {
          bodystyle,
          drivetrain,
          grade,
          nameplate,
          isSafetyModel
        }
      })
        .then(async (response) => {
          const json = await response.json()
          const { success, errorMsg } = json
          if (!success) {
            this.setState({
              errorMessage: errorMsg,
              loading: false
            })
          } else {
            // successful
            const { data } = json
            this.setState({
              loading: false,
              success: true,
              categories: data.categories,
              disclaimers: data.disclaimers
            })
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    })
  }

  _handleOpeningDisclaimer = (uniqueNumber) => {
    this.setState({
      activeDisclaimerCode: uniqueNumber
    })
  }

  render() {
    const { gradePickerData, heading, safetyModelBlurb, safetyModelExcess, safetyModelDisclaimer } = this.props
    const { categories, loading, activeDisclaimerCode } = this.state

    return (
      <div className={classnames({
        [styles.SpecificationsBlock]: true
      })}>
        <GradePicker
          heading={heading}
          data={gradePickerData}
          onChange={this._handleChange}
          safetyModelBlurb={safetyModelBlurb}
          safetyModelExcess={safetyModelExcess}
          safetyModelDisclaimer={safetyModelDisclaimer}
        />
        <Space />
        <Section sizeName="screen" horizontalPadding>
          { !loading && categories && categories.length > 0 &&
            <AccordionTextList
              styleName='box'
              data={categories.map((category, categoryIndex)=>{
              return {
                title: category.name,
                description: category.items.map((singleItem,singleItemIndex) => (
                  <div
                  key={`singleItemIndex-${categoryIndex}-${singleItemIndex}`}
                  className={classnames({
                    [styles.Description]: true
                  })}>
                    <div className={classnames({
                      [styles.DescriptionName]: true
                    })}>
                      <H6 withDetails>
                        {singleItem.name}
                      </H6>
                      <Space />
                    </div>
                    <div className={classnames({
                      [styles.DescriptionContent]: true
                    })}>
                      {singleItem.items.map((singleSpecs, singleSpecsIndex)=>{
                        let uniqueNumber = categoryIndex*1000000 + singleItemIndex * 10000 + singleSpecsIndex * 100
                        return (
                          <div
                          key={uniqueNumber}
                          className={classnames({
                            [styles.DescriptionSingleSpecs]: true
                          })}>
                            {singleSpecs && (!singleSpecs.disclaimer || !singleSpecs.disclaimer.disclaimerCode) &&
                              <div>
                                {singleSpecs.key} {singleSpecs.content && <span className={classnames({
                                  [styles.GreyDark]: true
                                })}>{singleSpecs.content}</span>}
                              </div>
                            }
                            {singleSpecs && singleSpecs.disclaimer && singleSpecs.disclaimer.disclaimerCode &&
                              <span
                                className={classnames({
                                  [styles.DescriptionSingleSpecsDisclaimer]: true
                                })}
                                onClick={()=>this._handleOpeningDisclaimer(uniqueNumber)}
                              >
                                {singleSpecs.key} {singleSpecs.content && <span className={classnames({
                                  [styles.GreyDark]: true
                                })}>{singleSpecs.content}</span>}
                                <Disclaimer
                                  key={`Disclaimer-${uniqueNumber}`}
                                  text={singleSpecs.disclaimer.disclaimerCode}
                                  show={activeDisclaimerCode === uniqueNumber}
                                >
                                  {singleSpecs.disclaimer.disclaimerText}
                                </Disclaimer>
                              </span>
                            }
                          </div>
                        )
                      })}
                    </div>
                  </div>
                ))
              }
            })} />
          }
          {loading && <LoadingSection visible />}
        </Section>
        <Space />
      </div>
    )
  }
}


export default SpecificationsBlock



// WEBPACK FOOTER //
// ./src/AtomicContainers/SpecificationsBlock/SpecificationsBlock.jsx